import { IconDeviceFloppy, IconX } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { Button, Card, Grid, Group, PasswordInput, TextInput } from '@mantine/core';
import { useSelector } from 'react-redux';
import useFetch from '../../../helpers/useFetch';
import ErrorMessage from '../../ErrorMessage';
import Spinner from '../../Spinner';

const SettingsTabAWS = () => {
  const [awsAccount, setAwsAccount] = useState();
  const [initialAwsAccount, setInitialAwsAccount] = useState();
  const [loadError, setLoadError] = useState();
  const [loading, setLoading] = useState(false);
  const [userError, setUserError] = useState(false);
  const { domain } = useSelector((state) => state.domain);
  const fetch = useFetch();

  useEffect(() => {
    fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/awsAccounts`)
      .then(({ awsAccount }) => {
        setAwsAccount(awsAccount || {});
        setInitialAwsAccount(awsAccount || {});
      })
      .catch(setLoadError);
  }, [domain.accountId, domain.id, fetch]);

  if (awsAccount === undefined) {
    return <Spinner />;
  }

  if (loadError) {
    return <ErrorMessage message={loadError?.message} />;
  }

  const submitForm = (e) => {
    e.preventDefault();
    setUserError(undefined);
    setLoading(true);
    fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/awsAccounts`, {
      method: 'POST',
      body: JSON.stringify(awsAccount),
    })
      .then(({ awsAccount }) => {
        setAwsAccount(awsAccount || {});
        setInitialAwsAccount(awsAccount || {});
      })
      .catch(setUserError)
      .finally(() => setLoading(false));
  };

  const del = () => {
    setUserError(undefined);
    setLoading(true);
    fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/awsAccounts`, {
      method: 'DELETE',
    })
      .then(() => {
        setAwsAccount({});
        setInitialAwsAccount({});
      })
      .catch(setUserError)
      .finally(() => setLoading(false));
  };

  const handleChange = (e) => {
    setAwsAccount((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const dirty = JSON.stringify(initialAwsAccount) !== JSON.stringify(awsAccount);

  return (
    <form onSubmit={submitForm}>
      <Card withBorder>
        <Card.Section p="md">
          <Grid mb="md">
            <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
              <label>Access Key ID</label>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 8 }}>
              <TextInput
                name="accessKeyId"
                autoComplete="new-password"
                value={awsAccount.accessKeyId || ''}
                onChange={handleChange}
              />
            </Grid.Col>
          </Grid>
          <Grid mb="md">
            <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
              <label>Secret Access Key</label>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 8 }}>
              <PasswordInput
                name="secretAccessKey"
                value={awsAccount.secretAccessKey || ''}
                onChange={handleChange}
                autoComplete="new-password"
              />
            </Grid.Col>
          </Grid>
        </Card.Section>
      </Card>
      <Group justify="flex-end" mt="md">
        {initialAwsAccount.accessKeyId && (
          <Button color="red" disabled={loading} type="button" onClick={del} leftSection={<IconX size={16} />}>
            Disconnect
          </Button>
        )}

        <Button
          disabled={!dirty || loading || !awsAccount.accessKeyId || !awsAccount.secretAccessKey}
          type="submit"
          leftSection={<IconDeviceFloppy size={16} />}
        >
          {dirty ? 'Save' : 'Saved'}
        </Button>
      </Group>
      {userError && <ErrorMessage message={userError?.message} />}
    </form>
  );
};

export default SettingsTabAWS;
